
const ContactBoxes = () => {
    // console.log(contactUsInfo.admin.address);
    return (
        <div className="row justify-content-center">
            <div className="col-xl-4 col-sm-6 mb-4">
                <div className="contact-box text-center shimmerBox">
                    <i className="fal fa-map-marker-alt"></i>
                    <div className="address"><div className="shine shimmerLine"></div></div>
                </div>
            </div>
            <div className="col-xl-4 col-sm-6 mb-4">
                <div className="contact-box text-center shimmerBox">
                    <i className="fal fa-phone"></i>
                    <div className="phone"><div className="shine shimmerLine"></div></div>
                </div>
            </div>
            <div className="col-xl-4 col-sm-6 mb-4">
                <div className="contact-box text-center shimmerBox">
                    <i className="fal fa-envelope"></i>
                    <div className="mail"><div className="shine shimmerLine"></div></div>
                </div>
            </div>
        </div>
    )
}

export default ContactBoxes;